import { t, useLocale } from '../localization/adminText';
import { BlockStack, Text } from './admin-ui';
import { riskScore } from '../utils/riskScore';

export default function RiskScoreBreakdown({ assessment }) {
  useLocale();
  const history = assessment.history_score;
  const matchLabels = { ip: 'IP', phone: 'Phone', email: 'Email', phone_email: 'Same phone and email', phone_address: 'Same phone and address' };
  return <BlockStack gap="100">
    <Text as="p">{t('Risk score: {0}', [riskScore({ risk_assessment: assessment }) ?? '—'])}</Text>
    <Text as="p" tone="subdued">{t('Behavior +{0} · History +{1}', [assessment.behavior_score ?? '—', history?.score ?? '—'])}</Text>
    {history?.status === 'unavailable' && <Text as="p" tone="subdued">{t('Historical score is unavailable.')}</Text>}
    {history?.status === 'disabled' && <Text as="p" tone="subdued">{t('Historical scoring is disabled.')}</Text>}
    {history?.status === 'ready' && <>
      {history.match_type ? <Text as="p">{t('History match: {0} (+{1})', [t(matchLabels[history.match_type] || 'Unknown'), history.base_score])}</Text>
        : <Text as="p" tone="subdued">{t('No recent confirmed refusal match.')}</Text>}
      {history.repeat_score > 0 && <Text as="p">{t('{0} refused orders: +{1}', [history.refusals, history.repeat_score])}</Text>}
      {history.undated_refusals > 0 && <Text as="p" tone="subdued">{t('{0} matched refusal records have no valid date and do not add points.', [history.undated_refusals])}</Text>}
      <Text as="p" tone="subdued">{t('Phone/email: {0} days; IP: {1} days.', [history.contact_window_days, history.ip_window_days])}</Text>
    </>}
  </BlockStack>;
}
